import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import ProgressBar from "react-bootstrap/ProgressBar";

import "./styles.scss";

const MapProgressBar = ({
  currentPosition,
  startPosition,
  windowStartTime,
  windowEndTime,
  vehicleSrc,
}) => (
  <div className={"mydpd-map-progress-bar"}>
    <img
      id="Progress-truck"
      style={{ left: `${currentPosition}%` }}
      className={"vehicle-img"}
      src={vehicleSrc}
      alt="truck"
    />
    <ProgressBar className={"progress-bar-container"}>
      <ProgressBar className={"bar1"} now={currentPosition} key={1} />
      <ProgressBar
        className={"bar2"}
        now={startPosition - currentPosition}
        key={2}
      />
      <ProgressBar className={"bar3"} now={100 - startPosition} key={3} />
    </ProgressBar>
    <span
      style={{ left: `${startPosition}%` }}
      className={classNames(
        "time",
        "time-start",
        startPosition > 90 && "time-start-shift"
      )}
    >
      {windowStartTime}
    </span>
    <span className={classNames("time", "time-end")}>{windowEndTime}</span>
  </div>
);

MapProgressBar.propTypes = {
  currentPosition: PropTypes.number.isRequired,
  startPosition: PropTypes.number.isRequired,
  windowStartTime: PropTypes.string.isRequired,
  windowEndTime: PropTypes.string.isRequired,
  vehicleSrc: PropTypes.string,
};

export default MapProgressBar;
